var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWalletMinus = function SvgWalletMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "m21.5 4.2-.05.117-4.834 11.217h-4.75c-1.133 0-2.2.216-3.2.65l2.917-6.967.066-.15.1-.267c.05-.116.084-.216.134-.3 2.183-5.05 4.65-6.2 9.616-4.3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.484 15.867a8.428 8.428 0 0 0-2.35-.334H16.617l4.834-11.216.05-.117c.233.084.483.2.733.284l3.683 1.55c2.05.85 3.483 1.733 4.367 2.8.15.2.283.383.417.6.15.233.266.466.333.716.067.15.117.284.15.434.433 1.416.166 3.133-.7 5.283Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.266 23.666v3.25c0 .334-.017.667-.034.984-.316 5.833-3.566 8.767-9.733 8.767h-13c-.417 0-.8-.034-1.183-.084-5.3-.35-8.134-3.183-8.5-8.483-.05-.4-.084-.784-.084-1.184v-3.25c0-3.35 2.034-6.233 4.934-7.483 1-.433 2.066-.65 3.2-.65h16.266c.817 0 1.6.117 2.35.334 3.334 1.016 5.784 4.116 5.784 7.8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "m11.582 9.217-2.916 6.966c-2.9 1.25-4.934 4.134-4.934 7.484v-4.884a9.748 9.748 0 0 1 7.85-9.566ZM36.266 18.784v4.883c0-3.683-2.45-6.783-5.784-7.8.867-2.15 1.134-3.867.7-5.283a2.226 2.226 0 0 0-.15-.434 9.734 9.734 0 0 1 5.234 8.634Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.167 27.917h-8.333a1.26 1.26 0 0 1-1.25-1.25c0-.683.567-1.25 1.25-1.25h8.333c.684 0 1.25.567 1.25 1.25a1.26 1.26 0 0 1-1.25 1.25Z",
    fill: "currentColor"
  })));
};
export default SvgWalletMinus;